import { Autocomplete, Divider, Grid, TextField, Typography } from '@mui/material'
import React, { useContext, useEffect, useState } from 'react'
import contactStyle from "../../../../../assets/styles/componentStyles/campaignContactStyles/campaignContactStyle.module.scss"
import globalStyles from "../../../../../assets/styles/global.module.scss";
import styles from "../../../../../assets/styles/componentStyles/chatbotStyles/chats.module.scss";
import { useSearchParams } from 'react-router-dom';
import GlobalButton from '../../../../../components/utility/globalButton/button';
import { UserContext, UserContextPayload } from '../../../../../context/userContext';
import { currentActiveChatbotThreadTypeNew, threadTags, threadTagsData } from '../../../../../models/axiosModel';
import agent from '../../../../../services/api';
import { filterAutocompleteOptionsWithException } from '../../../../../utils/constants';
import RenderCustomOption from '../../../../../components/global/autocomplete/renderCustomOption';
import { useGenericStore } from '../../../../../store/genericStore';
import { useShallow } from 'zustand/react/shallow';
import { getNewThreadTagObj, METADATA_KEYS } from '../../../constants';
import { renderThreadTagChip } from '../../../renderUtils';
import { useRuleBasedInboxStore } from '../../../../../store/ruleBasedInboxStore';
import { getMetadataValue } from '../../../utils';

interface threadTagPayload {
    ticket_tag_id: string,
}

const AssignThreadTagPopup = () => {

    const { currentActiveChatbotThread, setCurrentActiveChatbotThread, setFlagAssignThreadTagPopup, threadTagsData, getThreadTagApi, setSelectedThreadTag, setFlagUpdateThreadTagPopup, setFlagDeleteThreadTagConfirmation } = useRuleBasedInboxStore(useShallow((state) => ({
        currentActiveChatbotThread: state.currentActiveChatbotThread,
        setCurrentActiveChatbotThread: state.setCurrentActiveChatbotThread,
        setFlagAssignThreadTagPopup: state.setFlagAssignThreadTagPopup,
        threadTagsData: state.threadTagsData,
        getThreadTagApi: state.getThreadTagApi,
        setSelectedThreadTag: state.setSelectedThreadTag,
        setFlagUpdateThreadTagPopup: state.setFlagUpdateThreadTagPopup,
        setFlagDeleteThreadTagConfirmation: state.setFlagDeleteThreadTagConfirmation,
    })))

    const { showSuccess } = useGenericStore(useShallow((state) => ({
        showSuccess: state.showSuccess
    })))

    const { setFlagLoading, handleError } = useContext(UserContext) as UserContextPayload
    
    const [searchParams] = useSearchParams();
    const chatbotUserId = searchParams.get('chatbot_user_id') ?? (currentActiveChatbotThread ? currentActiveChatbotThread?.thread_id : "");

    const getDefaultValueOfPayload = () => {
        if((currentActiveChatbotThread && currentActiveChatbotThread?.thread_tags && currentActiveChatbotThread?.thread_tags?.length > 0)){
            return currentActiveChatbotThread?.thread_tags?.map((tags) => {
                return {
                    ticket_tag_id: tags?.ticket_tag_id,
                }
            });
        }
        return [];
    }

    const [payload, setPayload] = useState<threadTagPayload[]>(getDefaultValueOfPayload());

    const getThreadTagApiCall = async () => {
        setFlagLoading((prev) => ({ ...prev, flagRoundLoader: true }));
        const res = await getThreadTagApi();
        if(!(res.status)){
            handleError(res);
        }
        setFlagLoading((prev) => ({ ...prev, flagRoundLoader: false }));
    }

    useEffect(() => {
        if(!threadTagsData){
            getThreadTagApiCall(); // GET Thread Tag API Call.
        }
    }, []);

    const getNameOfTheUser = () => {
        if(currentActiveChatbotThread){
            return getMetadataValue(currentActiveChatbotThread?.thread_metadata, METADATA_KEYS['NAME']);
        } 
        return "UNKNOWN"; 
    }

    const getValueOfThreadTags = () => {
        if(threadTagsData && threadTagsData?.length > 0){
            return threadTagsData?.filter((tags) => payload?.some((tag) => tag?.ticket_tag_id == tags?.ticket_tag_id));
        } 
        return [];
    }

    const onChangeOfThreadTag = (value: threadTagsData[]) => {
        const updatedPayload = value?.map((tag) => {
            return {
                ticket_tag_id: tag?.ticket_tag_id,
            }
        })
        setPayload(updatedPayload);
    }

    const handleEditFieldData = (event: React.MouseEvent<HTMLDivElement, MouseEvent>, option: threadTagsData) => {
        event.stopPropagation();
        setSelectedThreadTag(option);
        setFlagUpdateThreadTagPopup(true);
    }

    const handleDeleteFieldData = (event: React.MouseEvent<HTMLDivElement, MouseEvent>, option: threadTagsData) => {
        event.stopPropagation();
        setSelectedThreadTag(option);
        setFlagDeleteThreadTagConfirmation(true);
    }

    const onClickOfNewTagItem = () => {
        setSelectedThreadTag(null);
        setFlagUpdateThreadTagPopup(true);
    }

    const onClickOfCancel = () => {
        setFlagAssignThreadTagPopup(false);
    }

    const onClickOfAssignBtn = async () => {
        setFlagLoading((prev) => ({ ...prev, flagRoundLoader: true }));

        const assignTagPayload = {
            thread_id: chatbotUserId ?? "", 
            tag_ids: payload,
        }

        const res = await agent.assignThreadTags.put(assignTagPayload);

        if(!(res.status)){
            handleError(res);
        } else {
            showSuccess(`Tags assigned successfully for ${getNameOfTheUser()}`)
            let updatedCurrentThread = currentActiveChatbotThread as currentActiveChatbotThreadTypeNew;
            updatedCurrentThread = {
                ...updatedCurrentThread,
                thread_tags: payload?.map((tag: threadTagPayload) => {
                    const existingTag = updatedCurrentThread?.thread_tags?.find((threadTag) => threadTag?.ticket_tag_id == tag?.ticket_tag_id);
                    if(existingTag){
                        return existingTag;
                    } else {
                        const newTag = threadTagsData?.find((threadTag) => threadTag?.ticket_tag_id == tag?.ticket_tag_id);
                        return newTag;
                    }
                }) as threadTags[],
            }
            setCurrentActiveChatbotThread(updatedCurrentThread);
        }
        setFlagLoading((prev) => ({ ...prev, flagRoundLoader: false }));
        onClickOfCancel();
    }

    const getThreadTagDataOptions = () => {
        if(threadTagsData){
            return [...(threadTagsData), getNewThreadTagObj]
        } else {
            return [];
        }
    }

    const renderThreadTagOption = (option: threadTagsData) => (
        renderThreadTagChip(option?.ticket_tag_name, option?.ticket_tag_color, { isOption: true })
    )

    const renderThreadTagTags = (value: threadTagsData[], getTagProps: (params: { index: number }) => object) => 
        value?.map((option, index) => renderThreadTagChip(option?.ticket_tag_name, option?.ticket_tag_color, { key: option?.ticket_tag_id, ...getTagProps({ index }) }));

    return (
        <>
            <Grid item xs={12}>
                <Grid container direction={"column"} justifyContent={"center"}>
                    <Grid item textAlign={"center"}>
                        <Typography className={contactStyle.popupTitleTypography}>{`Assign Tags to ${getNameOfTheUser()}`}</Typography>
                    </Grid> 

                    <Divider className={contactStyle.popupTitleDivider} /> 

                    <Grid item>
                        <Grid container className={`${contactStyle.popupBodyGridContainer}`} gap={2}>

                            <Grid item xs={12} className={globalStyles.fullwidth}>
                                <Grid container gap={1} direction={"column"}>
                                    <Grid item>
                                        <Typography className={contactStyle.popupFieldTypography}>
                                            Tags
                                        </Typography>
                                    </Grid>
                                    <Grid item>
                                        <Autocomplete
                                            className={`${styles.threadTagAutocomplete}`}
                                            options={getThreadTagDataOptions()}
                                            getOptionLabel={(option) => option?.ticket_tag_name || ''}
                                            filterOptions={(options, state) => filterAutocompleteOptionsWithException(options, state, "ticket_tag_name", "ticket_tag_id")}
                                            multiple
                                            value={getValueOfThreadTags()}
                                            onChange={(_: React.SyntheticEvent, value: threadTagsData[]) => { onChangeOfThreadTag(value); }}
                                            isOptionEqualToValue={(option, value) =>
                                                option.ticket_tag_id === value.ticket_tag_id
                                            }
                                            renderInput={(params) => <TextField {...params} placeholder="Select Tags" />}
                                            ListboxProps={{ className: contactStyle.singleContactListbox  }}
                                            renderOption={(props: React.HTMLAttributes<HTMLLIElement>, option: threadTagsData) => {
                                                return (
                                                    <RenderCustomOption
                                                        autocompleteRenderOptionProps={props} 
                                                        option={option} 
                                                        customOptionName={"New Tag"}
                                                        optionName={option['ticket_tag_name']}
                                                        optionLabelKey={'ticket_tag_id'}
                                                        onClickOfCustomOption={() => onClickOfNewTagItem()}
                                                        flagShowEditOptionIcon
                                                        onClickOfEditOption={(event) => handleEditFieldData(event, option)}
                                                        flagShowDeleteOptionIcon
                                                        onClickOfDeleteOption={(event) => handleDeleteFieldData(event, option)}
                                                        flagRenderCustomOption
                                                        renderCustomOption={(option) => renderThreadTagOption(option)}
                                                    />
                                                );
                                            }}
                                            renderTags={(value, getTagProps) => renderThreadTagTags(value, getTagProps)}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>

                            <Grid item xs={12} mt={1} mb={1}>
                                <Grid container gap={2} justifyContent={"center"}>
                                    <GlobalButton
                                        className='borderedButtonStyle'
                                        buttonText="Cancel"
                                        sx={{ width: "120px" }}
                                        onClick={() => onClickOfCancel()}
                                    />
                                    <GlobalButton
                                        className='primaryButtonStyle'
                                        buttonText="Assign"
                                        sx={{ width: "120px" }}
                                        onClick={() => onClickOfAssignBtn()}
                                    />
                                </Grid>
                            </Grid>

                        </Grid>
                    </Grid>
                </Grid>
            </Grid>

        </>
    )
}

export default AssignThreadTagPopup
